<script lang="ts">
	import BaseInput from "@components/inputs/BaseInput.svelte";
	import Button from "@components/inputs/Button.svelte";
	import { supabase } from "@lib/supabase";
	import { toast } from "svelte-sonner";

	// Props for pre-filled user information
	export let email: string;
	export let name: string;
	export let phoneNumber: string = ""; // Optional phone number

	let password = "";
	let loading = false;
	let success = false;

	async function handleSubmit() {
		loading = true;
		success = false;

		try {
			const { error: signUpError } = await supabase.auth.signUp({
				email,
				password,
				options: {
					data: {
						name,
						phone: phoneNumber || null
					},
					emailRedirectTo: `${window.location.origin}/signin?confirmation=success`
				}
			});

			if (signUpError) {
				toast.error("Registratie mislukt", {
					description: signUpError.message
				});
			} else {
				toast.success("Registratie gelukt", {
					description:
						"Je account is aangemaakt. Controleer je e-mail om je account te bevestigen."
				});
				success = true;
			}
		} catch (e) {
			toast.error("Registratie mislukt", {
				description: "Er is een onverwachte fout opgetreden"
			});
		} finally {
			loading = false;
		}
	}
</script>

<form
	on:submit|preventDefault={handleSubmit}
	class="flex w-full flex-col gap-4 p-2"
>
	<div class="mb-4 mt-[-32px] rounded-lg">
		<p class="mb-2 font-semibold text-green-600">
			Bedankt voor je sollicitatie!
		</p>
		<p class="text-gray-700">
			Maak nu je account aan, en solliciteer voortaan met één klik!
		</p>
	</div>

	<BaseInput
		bind:value={password}
		class="text-gray-700"
		type="password"
		name="password"
		required
		minLength={8}
		autocomplete="new-password"
		placeholder="Wachtwoord"
		showPasswordToggle={true}
	/>

	<Button color="primary" type="submit" disabled={loading || success}>
		{#if loading}
			Account aanmaken...
		{:else if success}
			Account aangemaakt
		{:else}
			Account aanmaken
		{/if}
	</Button>
</form>
